module.exports = __webpack_public_path__ + "static/media/tick-white.fec61ee9.svg";